<style src="./MonitorMessage.scss" lang="scss"></style>
<template>
  <section class="wrapper wrapper-content animated fadeIn monitor-message">
    <section class="row">
      <section class="col-lg-4 users">
        <user-list />
      </section>

      <section class="col-lg-8 messagearea">
        <chat-message :messages="messages" me="web" />
      </section>
    </section>
  </section>
</template>

<script>
import UserList from './components/user-list/UserList';
import ChatMessage from '@/components/chat-message/ChatMessage';
import socket from '@/store/socket';
import { MESSAGES_EVENTS } from '@/config/config';
import { mapGetters } from 'vuex';
export default {
  components: {
    UserList,
    ChatMessage,
  },

  computed: {
    ...mapGetters({
      messages: 'MESSAGES/monitorMessages',
    }),
  },

  unmounted() {
    socket.off(MESSAGES_EVENTS.PRIVATE_MESSAGE);
  },
};
</script>